<template>
  <DBox :id="'cmp-royalty-contracts-sidewindow-releases'" :addButton="false" :addLink="false"
    :addLinkLabel="$dft.capHead($t('add_new_release'))" :leftMenu="[
      {
        text: this.$dft.snakeCaseToWords($t('+ add_new_release')),
        value: 'add_new_release',
      },
      {
        text: this.$dft.snakeCaseToWords($t('- remove_all_releases')),
        value: 'remove_all_releases', buttonStyle: 1
      }
    ]" :rightMenu="[
      {
        text: $dft.snakeCaseToWords($t('btn_auto_fill_rom_releases')),
        value: 'btn_auto_fill_rom_releases',
      },
    ]" @menuClick="onRightMenuClick" @add_click="onAddReleases" :searchButton="true" :searchFlag="searchFlag"
    :badgeButtons="filterExists
      ? [
        {
          text: 'Reset Filters',
          value: 'reset_filters',
          icon: 'delete-white'
        }
      ]
      : []
      " @searchClick="onSearchClick" @badgeClick="onBadgeClick">
    <div v-if="searchFlag" class="search-controls">
      <InputField :value="searchString" :placeholder="'Search'" :config="{
        borderStyle: 'bottom',
        width: '124px'
      }" @keyup="onSearchInputKeyup"></InputField>
    </div>
    <div class="ut-fh" :style="{
      height: this.searchFlag ? `calc(100% - 52px)` : undefined,
    }">
      <NTable class="dbox1" id="royalty-contracts-sidewindow-releases-list" :config="tableConfig" :headers="headers"
        :items="list" :showNoItems="false">
        
          <template v-slot:item="{ item, tdcon }">
            <template v-if='mechanical_flag'>
              <tr>
            <td v-bind="tdcon('release_code')">
              <span @click.stop="(e) => onSelectRelease(item)" class="txtov" :title="item['identifier']">
                {{ item["identifier"] }}
              </span>
            </td>
            <td v-bind="tdcon('label')">
              <span @click.stop="(e) => onSelectRelease(item)" class="txtov" :title="item['label_name']">
                {{ item["label_name"] }}
              </span>
            </td>

            <td v-bind="tdcon('releases')">
              <span @click.stop="(e) => onSelectRelease(item)" class="txtov ut-link ut-text-accent5"
                :title="item['release_title']">
                {{ item['release_name']}}
              </span>
            </td>
            <td v-bind="tdcon('release_type')">
              <span @click.stop="(e) => onSelectRelease(item)" class="txtov" :title="item['release_type']">
                {{ item["release_type"] }}
              </span>
            </td>
            <td v-bind="tdcon('cost_share')">
              <TextField2 class="dbox1" :ta="'right'" :id="'share'" :showLabel="false" :value="item['share']"
                :type="'percent'" @blur="(e) => onTextFieldValueChange(e, item)" />
            </td>
           <!-- <td v-bind="tdcon('recoupable')">
              <div style="margin-left: 80px;" class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input type="checkbox" :name="`recoupable-${item['recoupable']}`"
                    :id="`recoupable-${item['contract_pos_id']}`" :checked="item['allow_cost_split_flag'] == '1'"
                    @click="(e) => onContractRecoupable(e, item)" />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td> -->
            <td v-bind="tdcon('options')">
              <img src="static/icons/delete.svg" @click.stop="(e) => onDeleteReleases(item)"
                class="dt-icon v5 s1 ut-center" alt />
            </td>
          </tr>
          
        </template>
        <template v-else>
          <tr>
            <td v-bind="tdcon('release_code')">
              <span @click.stop="(e) => onSelectRelease(item)" class="txtov" :title="item['identifier']">
                {{ item["identifier"] }}
              </span>
            </td>
            <td v-bind="tdcon('label')">
              <span @click.stop="(e) => onSelectRelease(item)" class="txtov" :title="item['label_name']">
                {{ item["label_name"] }}
              </span>
            </td>

            <td v-bind="tdcon('releases')">
              <span @click.stop="(e) => onSelectRelease(item)" class="txtov ut-link ut-text-accent5"
                :title="item['release_title']">
                {{ `${item['release_artist']} - ${item["release_title"]}` }} | {{ item["contract_key"] }}
              </span>
            </td>
            <td v-bind="tdcon('release_type')">
              <span @click.stop="(e) => onSelectRelease(item)" class="txtov" :title="item['release_type']">
                {{ item["release_type"] }}
              </span>
            </td>
            <td v-bind="tdcon('share')">
              <TextField2 class="dbox1" :ta="'right'" :id="'share'" :showLabel="false" :value="item['share']"
                :type="'percent'" @blur="(e) => onTextFieldValueChange(e, item)" />
            </td>
            <td v-bind="tdcon('recoupable')">
              <div style="margin-left: 80px;" class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input type="checkbox" :name="`recoupable-${item['recoupable']}`"
                    :id="`recoupable-${item['contract_pos_id']}`" :checked="item['allow_cost_split_flag'] == '1'"
                    @click="(e) => onContractRecoupable(e, item)" />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <img src="static/icons/delete.svg" @click.stop="(e) => onDeleteReleases(item)"
                class="dt-icon v5 s1 ut-center" alt />
            </td>
          </tr>
        </template>
          </template>
       
     
 
       
      </NTable>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { EventHooks } from "../../../../plugins/text-field";
import { ContractsService } from "../../services/contracts.service";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
export default {
  components: {
    DBox,
    NTable,
  },
  props: ["channel", "selectedContractDetails"],
  data: function () {
    return {
      searchFlag: false,
      searchString: "",
      searchSubject$: new Subject(),
      scrollSubject: new Subject(),
      textFieldConfig: {
        height: 27,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
    };
  },
  mounted() {
    this.$subscribeTo(
      this.searchSubject$
        .asObservable()
        .pipe(debounceTime(500), distinctUntilChanged()),
      (searchString) => {
        this.searchModel = {
          ...this.searchModel,
          str: searchString,
        };
        this.searchString = searchString;
        this.$emit('emitSearchString', { searchString: searchString, action: 'releases' });
      }
    );
  },
  computed: {
    filterExists() {
      return this.searchString != "";
    },
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      });
    },

    headers: function () {
      return this.mechanical_flag? [
        createTableHeader("release_code", { mw: 120 }),
        createTableHeader("label", { mw: 250 }),
        createTableHeader("releases", { text: 'Artist / Title', minw: 300 }),
        createTableHeader("release_type",{mw:150}),
        createTableHeader("cost_share", { mw: 80, minw: 80, ta: "right", text: `${this.$t("cost_share")}`, }),
        createTableHeader("options", { text: false, mw: 30, ta: "center" }),
        // createTableHeader("recoupable", { mw: 150, minw: 150, ta: 'right' }),
      ]:[
        createTableHeader("release_code", { mw: 120 }),
        createTableHeader("label", { mw: 120 }),
        createTableHeader("releases", { text: 'Artist / Title', mw: 300, minw: 300 }),
        createTableHeader("release_type",),
        createTableHeader("share", { mw: 80, minw: 80, ta: "right" }),
        createTableHeader("recoupable", { mw: 150, minw: 150, ta: 'right' }),
        createTableHeader("options", { text: false, mw: 30, ta: "center" }),
      ];
    },
    list: function () {
      return this.selectedContractDetails.releases || [];
    },
    contract_id: function () {
      return this.$route.params.contract_id;
    },
    mechanical_flag:function(){
     return this.selectedContractDetails?.contract?.mechanical_flag;
    }
  },
  methods: {

    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(event.target.value);
    },
    onSearchClick: function () {
      this.searchFlag = !this.searchFlag;
      this.$emit('showSearchFlag', this.searchFlag);
    },
    onBadgeClick(badge) {
      if (badge == "reset_filters") {
        this.searchString = "";
        this.searchFlag = false;
        this.$emit('emitSearchString', { searchString: this.searchString, action: 'releases' });
        this.$emit('showSearchFlag', this.searchFlag);
      }
    },
    onSelectRelease: function (selectedRelease) {
      this.$emit("selected", selectedRelease.release_id);
    },

    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", { name, value, item });
    },

    onContractRecoupable: function (e, item) {
      if (e.target.checked) {
        this.$emit("changed", {
          name: "allow_cost_split_flag",
          value: 1,
          item,
          contract_id: this.selectedContractDetails.releases.contract_id,
        });
      } else {
        this.$emit("changed", {
          name: "allow_cost_split_flag",
          value: 0,
          item,
          contract_id: this.selectedContractDetails.releases.contract_id,
        });
      }
    },

    onAddReleases: function () {
      this.$emit("add_click", true);
    },

    onDeleteReleases: function (item) {
      // const confirmationResult = await confirmDelete(
      //   "Release",
      //   item.release_title
      // );
      // if (confirmationResult === "OK") {
      //   this.$emit("deleted", { ...item, channel: this.channel });
      // }
      this.$emit("deleted", { ...item, channel: this.channel });
    },
    onRightMenuClick: async function (menu) {
      if (menu == 'add_new_release') {
        this.onAddReleases();
      }
      else if (menu == 'remove_all_releases') {
        this.$emit("deletedAll", { channel: this.channel });
      }
      else {
       if(this.mechanical_flag){
        this.$router.push({
            ...this.$route,
            query: {
              modal: "auto_fill_from_release",
              contract_id: this.selectedContractDetails.contract.contract_id,
              mechanical_flag:this.mechanical_flag
              
            }
          });
       }
       else{
        const res = await ContractsService.contractReleaseCount(this.contract_id);
        console.log('res', res.data)
        if (res.data.release_count > 1) {
          this.$router.push({
            ...this.$route,
            query: {
              modal: "auto_fill_from_release",
              contract_id: this.selectedContractDetails.contract.contract_id,
              
            }
          });
    
        }
        else {
          const res1 = await ContractsService.contractRelatedReleases(this.contract_id);
          const ids = res1.data.releases.map(r => r.release_id);
          console.log('ids', ids)
         let res = await ContractsService.autoFillFromReleases({
        contract_id: this.contract_id,
        release_ids:JSON.stringify(ids)
        });
        this.$emit("added", res.data);
        }
       }
       


      }

    },
  },
};
</script>
<style lang="scss">
.cmp-royalty-contracts-sidewindow-releases {
  .search-controls {
    .input-field-container {
      margin: 10px;
    }
  }
}
</style>